type Props = {
  variant?: 'black' | 'white'
  withBar?: boolean
  className?: string
  height?: number
}

export default function YaslanLogo({
  variant = 'black',
  withBar = true,
  className = '',
  height = 28,
}: Props) {
  const fill = variant === 'white' ? '#ffffff' : '#0e0e14'
  // viewBox cropped around the wordmark + bar with extra right padding so
  // the final "n" never gets clipped at any rendered size.
  const viewBox = withBar ? '200 620 1820 820' : '200 620 1820 620'

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      className={className}
      style={{ height }}
      role="img"
      aria-label="Yaslan"
    >
      <g fill={fill}>
        {/* Y */}
        <path d="M350.99,638.8l97.97,164.56,113.42-161.4c.93-1.11,1.39-1.97,2.22-3.16h125.96s-2.73,3.91-2.73,3.91l-350.9,499.3-137.76,22.57-4.58.75,168.78-238.9-157.64-287.64h145.27Z" />
        {/* a1 */}
        <path d="M594.21,863.92l43.97-62.56,7.14-10.16h93.15c52.36,0,100.22,8.83,109.67,58.66,2.14,11.31.98,21.52-1.38,32.8l-40.98,208.38-233.52-.4c-56.49-6.95-70.39-48.84-58.89-97.15,10.37-43.58,43.59-71.08,89.47-78.26,45.03-7.05,93.43-5.21,139.25-10.43,9.84-1.12,16.95-9.6,15.72-18.92-1.52-11.46-10.08-21.95-23.11-21.95h-140.49ZM728.88,1020.37l9.29-61.69c-31.39,1.69-98.96,1.87-122.06,19.8-15.31,11.88-16.2,38.2,5.68,43.16,15.03,3.4,65.28,2.1,82.78,1.04,8.1-.49,15.61-.9,24.3-2.31Z" />
        {/* s */}
        <path d="M864,1018.4l168.49,1.99c20.59,0,36.96-25.93,14.34-36.39-42.07-19.47-144.16-9.77-155.49-69.29-10.89-57.23,36.76-123.51,97.06-123.51h179.6l-14.43,72.5-156.41.17c-17.72,1.2-30.16,23.32-9.87,32.01,40.12,17.18,147.05,12.21,157.7,64.88,12.12,59.94-41.66,130.15-103.7,130.15h-191.55" />
        {/* l */}
        <polygon points="1320.06 711.87 1245.14 1090.9 1153.73 1090.9 1228.26 711.87 1320.06 711.87" />
        {/* a2 */}
        <path d="M1338.82,863.92l12.53-63.72,1.77-9c7.91,0,74.87,0,84.06,0h73.51c49.64,0,95.01,8.83,103.96,58.66,2.03,11.31,1.72,22.92-.52,34.19l-41.08,206.98-219.92-.4c-53.55-6.95-66.72-48.84-55.83-97.15,9.83-43.58,41.32-71.08,84.81-78.26,42.68-7.05,88.57-5.21,132.01-10.43,9.32-1.12,16.07-9.6,14.9-18.92-1.44-11.46-9.56-21.95-21.9-21.95h-168.3ZM1501.6,1020.37l8.8-61.69c-29.76,1.69-93.81,1.87-115.7,19.8-14.51,11.88-15.36,38.2,5.39,43.16,14.25,3.4,61.89,2.1,78.48,1.04,7.68-.49,14.8-.9,23.04-2.31Z" />
        {/* n */}
        <path d="M1900.29,1091.03h-88.15l37.76-182.72c1.11-5.38,1.88-10.83,2.14-16.31.69-14.56-2.24-25.17-21.36-27.75-4.89-.66-30-1.07-50.89-.85-17.05.18-31.66,12.26-35.07,28.97l-40.57,198.66h-88.15l59.07-299.83h198.26c8.81,0,17.59,1.47,25.79,4.67,20.89,8.16,34.74,24.96,40.85,46.27,3.73,13.01,4.04,26.76,1.42,40.04l-41.11,208.86Z" />
        {/* Barre (horizontal bar) */}
        {withBar && (
          <path d="M56.88,1361.2l106.57-144.36s421.67-122.41,1702.29-76.95c0,0-1476.24,26.9-1808.87,221.31Z" />
        )}
      </g>
    </svg>
  )
}
